import { useEffect, useState } from "react";
import DashboardLayoutMain from "../../../layout/dashboard/DashboardLayoutMain";
import "../../../styles/dashboard/overview/DashboardOverview.css";
import { ALL_ICONS } from "../../../assets/icons/AllIcons";
import MultiLineChart from "./charts/MultiLineChart";
import MultiBarChart from "./charts/MultiBarChart";
import TitleTextFragment from "../../../components/fragment/title-text/TitleTextFragment";
import {
  RazorInputField,
  RazorNumberFormat,
  RazorTable,
  RazorTableRow,
} from "../../../components/razor-reuse";
import PieChartFragment from "./charts/PieChart";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../redux/type";
import {
  getCurrencyExchangeMetrics,
  getCustomerMetrics,
  getTransactionMetrics,
  getTransactionMetricsCounts,
} from "../../../redux/dashboard";
import { formatTime, reactSelectStyleTable } from "../../../utils/Helper";
import NoContentPage from "../../../layout/dashboard/no-content/NoContentPage";
import ExchangeCurrencyText from "../../../components/fragment/cur-text/ExchangeCurrencyText";
import { getAllExchangeRate } from "../../../redux/settings";
import PaginationFragment from "../../../components/fragment/pagination/PaginationFragment";
import CurrencyText from "../../../components/fragment/cur-text/CurrencyText";
import CurrencyExchangeBarChart from "./charts/CurrencyBarChart";
import { systemRoles } from "../../../utils/roles";

const DashboardOverview = () => {
  const {
    customer_metric,
    transaction_metric,
    cus_trans_info,
    loading_currency_exchange,
    loading_customer,
    loading_transaction,
  } = useSelector((state: RootState) => state.dashboard);
  const { user } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();

  const metricList = [
    {
      name: "Total Users",
      value:
        Object?.keys(cus_trans_info)?.length > 0
          ? RazorNumberFormat(cus_trans_info?.total_customers || 0, {
              hideDecimal: true,
              hideSymbol: true,
            })
          : "0",
      // rate: "5%",total_transaction_amount
      color: "#5C70AF",
    },
    {
      name: "Total Transactions ( NGN )",
      value:
        Object?.keys(cus_trans_info)?.length > 0
          ? RazorNumberFormat(
              cus_trans_info?.total_transaction_amount
                ?.total_transactions_NGN || 0,
              {
                // hideDecimal: true,
                // hideSymbol: true,
                symbol: "NGN",
                numberAbbreviate:
                  String(
                    cus_trans_info?.total_transaction_amount
                      ?.total_transactions_NGN
                  )?.length > 9,
              }
            )
          : "0",
      color: "#758089",
      symbol: "NGN",
    },
    {
      name: "Total Transactions ( CAD )",
      value:
        Object?.keys(cus_trans_info)?.length > 0
          ? RazorNumberFormat(
              cus_trans_info?.total_transaction_amount
                ?.total_transactions_CAD || 0,
              {
                // hideDecimal: true,
                // hideSymbol: true,
                symbol: "CAD",
                numberAbbreviate:
                  String(
                    cus_trans_info?.total_transaction_amount
                      ?.total_transactions_CAD
                  )?.length > 9,
              }
            )
          : "0",
      color: "#758089",
      symbol: "CAD",
    },
    {
      name: "Total Transactions  Count ",
      value:
        Object?.keys(transaction_metric)?.length > 0
          ? RazorNumberFormat(
              transaction_metric?.total_volume_insight[0]?.total_count,
              {
                numberAbbreviate:
                  String(
                    transaction_metric?.total_volume_insight[0]?.total_count
                  )?.length > 7,
                hideDecimal: true,
                hideSymbol: true,
              }
            )
          : "0",
      color: "#758089",
    },
  ];

  const customerMetriclabelList = [
    // { label: "Total customer", value: "40000", label_color: "#1E1E1E" },
    {
      label: "Signed Up Customers",
      value:
        Object?.keys(customer_metric)?.length > 0
          ? RazorNumberFormat(
              customer_metric?.customer_growth_insight[0]?.total_users,
              { hideDecimal: true, hideSymbol: true }
            )
          : "0",
      label_color: "#0F2B8E",
      tag: true,
    },
    {
      label: "Active Customers",
      value:
        Object?.keys(customer_metric)?.length > 0
          ? RazorNumberFormat(
              customer_metric?.customer_growth_insight[0]?.active_users,
              { hideDecimal: true, hideSymbol: true }
            )
          : "0",
      label_color: "#119C2BE5",
      tag: true,
    },
    {
      label: "Inactive Customers",
      value:
        Object?.keys(customer_metric)?.length > 0
          ? RazorNumberFormat(
              customer_metric?.customer_growth_insight[0]?.inactive_users,
              { hideDecimal: true, hideSymbol: true }
            )
          : "0",
      label_color: "#EC1410CC",
      tag: true,
    },
  ];

  const filterOptionCur = [
    { label: " Months", value: "year" },
    { label: " Weeks", value: "month" },
    { label: " Days", value: "day" },
  ];
  const [customerFilter, setCustomerFilter] = useState(filterOptionCur[0]);
  const [transFilter, setTransFilter] = useState(filterOptionCur[0]);
  const [currencyExchangeFilter, setCurExchangeFilter] = useState(
    filterOptionCur[0]
  );

  useEffect(() => {
    if (user?.permissions?.includes(systemRoles[11])) {
      dispatch(getTransactionMetricsCounts({}) as any);
    }

    if (user?.permissions?.includes(systemRoles[3])) {
      const obj = {
        interval: customerFilter?.value,
      };
      dispatch(getCustomerMetrics(obj) as any);
    }
    if (user?.permissions?.includes(systemRoles[11])) {
      const obj = {
        interval: transFilter?.value,
      };
      dispatch(getTransactionMetrics(obj) as any);
    }

    if (user?.permissions?.includes(systemRoles[26])) {
      const obj = {
        interval: currencyExchangeFilter?.value,
      };
      dispatch(getCurrencyExchangeMetrics(obj) as any);
    }
  }, [user, dispatch]);

  // const

  const { loading, exchange_rates } = useSelector(
    (state: RootState) => state.settings
  );
  const [currentPageVal, setCurrentPage] = useState(1);
  const tableHeaderList = [
    "Currency",
    "Rate",
    "Provider",
    "Date Modified",
    "Modified By",
  ];

  useEffect(() => {
    const obj = {
      page: currentPageVal,
      status: "",
      search: "",
    };
    if (user?.permissions?.includes(systemRoles[26])) {
      dispatch(getAllExchangeRate(obj as any) as any);
    }
  }, [currentPageVal, dispatch, user?.permissions]);

  return (
    <>
      <DashboardLayoutMain title=" Overview">
        <div
          onClick={() => {
            // console.log(
            //   processData(
            //     getArrayOfValues(
            //       "signed_up_customers",
            //       customer_metric?.customer_activity,
            //       true
            //     )
            //   )
            // );
          }}
          className="smartsend-overview-wrapper-index-box select-none"
        >
          {/* two cards start */}
          <div className="overview-metric-card-box-wrapper">
            {metricList?.map((chi, idx) => {
              if (chi.name === "Total Users") {
                return (
                  <div key={idx} className="carrd-box">
                    {(!user?.permissions?.includes(systemRoles[3]) ||
                      !user?.permissions?.includes(systemRoles[11])) && (
                      <div className="absolute inset-0 z-20 bg-white/20 backdrop-blur-[14px] backdrop-saturate-150 rounded-[1.6rem] grid place-content-center">
                        {ALL_ICONS.padLock}
                      </div>
                    )}
                    <div className="name-sym-box">
                      <p style={{ color: chi?.color || "" }} className="name">
                        {chi?.name}
                      </p>
                      {chi?.symbol && (
                        <>
                          <CurrencyText currency={chi?.symbol} />
                        </>
                      )}
                    </div>

                    {/* value rate box start */}
                    <div className="value-rate-box">
                      <p className="value">{chi?.value}</p>

                      {/* {chi?.rate && (
                      <div className="rate-box">
                        <figure className="img-box">
                          {ALL_ICONS?.incre_decre_arrow()}
                        </figure>
                        <p className="rate">{chi?.rate}</p>
                      </div>
                    )} */}
                    </div>
                    {/* value rate box end */}
                  </div>
                );
              }
              return (
                <div key={idx} className="carrd-box">
                  {!user?.permissions?.includes(systemRoles[11]) && (
                    <div className="absolute inset-0 z-20 bg-white/20 backdrop-blur-[14px] backdrop-saturate-150 rounded-[1.6rem] grid place-content-center">
                      {ALL_ICONS.padLock}
                    </div>
                  )}
                  <div className="name-sym-box">
                    <p style={{ color: chi?.color || "" }} className="name">
                      {chi?.name}
                    </p>
                    {chi?.symbol && (
                      <>
                        <CurrencyText currency={chi?.symbol} />
                      </>
                    )}
                  </div>

                  {/* value rate box start */}
                  <div className="value-rate-box">
                    <p className="value">{chi?.value}</p>

                    {/* {chi?.rate && (
                      <div className="rate-box">
                        <figure className="img-box">
                          {ALL_ICONS?.incre_decre_arrow()}
                        </figure>
                        <p className="rate">{chi?.rate}</p>
                      </div>
                    )} */}
                  </div>
                  {/* value rate box end */}
                </div>
              );
            })}
          </div>
          {/* two cards end */}

          {/* chart wrapper card start */}
          <div className="chart-wrapper-card">
            {/* left box start */}
            <div className="left-box">
              {/* title filter box start */}
              <div className="title-filter-box">
                <p className="title">Total Users</p>
                <div className="filter-box">
                  <RazorInputField
                    color="black-light"
                    type="select"
                    selectStyles={reactSelectStyleTable}
                    selectOption={filterOptionCur}
                    value={customerFilter}
                    onChange={(e: any) => {
                      setCustomerFilter(e);
                      const obj = {
                        interval: e?.value,
                      };
                      dispatch(getCustomerMetrics(obj) as any);
                    }}
                    disabled={!user?.permissions?.includes(systemRoles[3])}
                  />
                </div>
              </div>
              {/* title filter box end */}
              {/* chart wrapper start */}
              <div className="chart-wrapper">
                {loading_customer ? (
                  <>
                    {" "}
                    <NoContentPage height="35rem" loading={true} />
                  </>
                ) : (
                  <div className="inner-wrap">
                    {!user?.permissions?.includes(systemRoles[3]) && (
                      <div className="absolute inset-0 z-20 bg-white/20 backdrop-blur-[14px] backdrop-saturate-150 rounded-[1.6rem] grid place-content-center">
                        {ALL_ICONS.padLock}
                      </div>
                    )}
                    <MultiLineChart activeTab={customerFilter?.value} />
                  </div>
                )}
              </div>
              {/* chart wrapper end */}
            </div>
            {/* left box end */}
            {/* right box start */}
            <div className="right-box">
              {!user?.permissions?.includes(systemRoles[3]) && (
                <div className="absolute inset-0 z-40 bg-white/20 backdrop-blur-[14px] backdrop-saturate-150 rounded-[1.6rem] grid place-content-center">
                  {ALL_ICONS.padLock}
                </div>
              )}
              <p className="title">User Growth Insight</p>
              {/* percent box start */}
              {Object?.keys(customer_metric)?.length > 0 &&
                customer_metric?.customer_growth_insight[0]
                  ?.user_growth_percentage && (
                  <div className="percentage-box">
                    <p className="big-percent">{`${
                      Object?.keys(customer_metric)?.length > 0
                        ? RazorNumberFormat(
                            customer_metric?.customer_growth_insight[0]
                              ?.user_growth_percentage || 0,
                            { hideDecimal: true, hideSymbol: true }
                          )
                        : "0"
                    }%`}</p>
                    <div className="rate-box">
                      <figure className="img-box">
                        {ALL_ICONS?.incre_decre_arrow()}
                      </figure>
                      <p className="rate">{`5%`}</p>
                    </div>
                  </div>
                )}
              {/* percent box end */}
              {/* label value box wrapper start */}
              <div className="label-value-box-wrapper">
                {/* label value box start */}
                {customerMetriclabelList?.map((chi, idx) => {
                  return (
                    <div key={idx} className="label-value-box">
                      <div className="label">
                        {chi?.tag && (
                          <>
                            <div
                              style={{ backgroundColor: chi?.label_color }}
                              className="tag"
                            ></div>
                          </>
                        )}
                        <p
                          style={{ color: chi?.label_color }}
                          className="label-text"
                        >
                          {chi?.label}
                        </p>
                      </div>
                      <p className="value">: {chi?.value}</p>
                    </div>
                  );
                })}
                {/* label value box end */}
              </div>
              {/* label value box wrapper end */}
            </div>
            {/* right box end */}
          </div>
          {/* chart wrapper card end */}

          {/* chart wrapper card start */}
          <div className="chart-wrapper-card">
            {/* left box start */}
            <div className="left-box">
              {/* title filter box start */}
              <div className="title-filter-box">
                <p className="title">Transaction Activity</p>
                <div className="filter-box">
                  <RazorInputField
                    color="black-light"
                    type="select"
                    selectStyles={reactSelectStyleTable}
                    selectOption={filterOptionCur}
                    value={transFilter}
                    onChange={(e: any) => {
                      setTransFilter(e);
                      const obj = {
                        interval: e?.value,
                      };
                      dispatch(getTransactionMetrics(obj) as any);
                    }}
                    disabled={!user?.permissions?.includes(systemRoles[11])}
                  />
                </div>
              </div>
              {/* title filter box end */}
              {/* chart wrapper start */}
              <div className="chart-wrapper">
                {loading_transaction ? (
                  <>
                    {" "}
                    <NoContentPage height="35rem" loading={true} />
                  </>
                ) : (
                  <div className="inner-wrap">
                    {!user?.permissions?.includes(systemRoles[11]) && (
                      <div className="absolute inset-0 z-20 bg-white/20 backdrop-blur-[14px] backdrop-saturate-150 rounded-[1.6rem] grid place-content-center">
                        {ALL_ICONS.padLock}
                      </div>
                    )}
                    <MultiBarChart activeTab={transFilter?.value} />
                  </div>
                )}
              </div>
              {/* chart wrapper end */}
            </div>
            {/* left box end */}
            {/* right box start */}
            <div className="right-box">
              <p className="title">Transaction Volume Insight</p>
              {/* pie c hart wrap staert */}
              <div className="pie-chart-wrapper">
                {!user?.permissions?.includes(systemRoles[11]) && (
                  <div className="absolute inset-0 z-20 bg-white/20 backdrop-blur-[14px] backdrop-saturate-150 rounded-[1.6rem] grid place-content-center">
                    {ALL_ICONS.padLock}
                  </div>
                )}
                <div className="inner-wrap">
                  <PieChartFragment />
                </div>
              </div>
              {/* pie c hart wrap end */}
            </div>
            {/* right box end */}
          </div>
          {/* chart wrapper card end */}

          {/* chart wrapper card start */}
          <div className="chart-wrapper-card relative">
            {/* left box start */}

            <div className="left-box relative">
              {!user?.permissions?.includes(systemRoles[2]) && (
                <div className="absolute inset-0 z-20 bg-white/20 backdrop-blur-[14px] backdrop-saturate-150 rounded-[1.6rem] grid place-content-center">
                  {ALL_ICONS.padLock}
                </div>
              )}
              {/* title filter box start */}
              <div className="title-filter-box">
                <p className="title">Currency Exchange</p>
                <div className="filter-box ">
                  <RazorInputField
                    color="black-light"
                    type="select"
                    selectStyles={reactSelectStyleTable}
                    selectOption={filterOptionCur}
                    value={currencyExchangeFilter}
                    onChange={(e: any) => {
                      setCurExchangeFilter(e);
                      const obj = {
                        interval: e?.value,
                      };
                      dispatch(getCurrencyExchangeMetrics(obj) as any);
                    }}
                  />
                </div>
              </div>
              {/* title filter box end */}
              {/* chart wrapper start */}
              <div className="chart-wrapper">
                {loading_currency_exchange ? (
                  <>
                    {" "}
                    <NoContentPage height="35rem" loading={true} />
                  </>
                ) : (
                  <div className="inner-wrap">
                    <CurrencyExchangeBarChart
                      activeTab={currencyExchangeFilter?.value}
                    />
                  </div>
                )}
              </div>
              {/* chart wrapper end */}
            </div>
            {/* left box end */}
          </div>
          {/* chart wrapper card end */}

          {user?.permissions?.includes(systemRoles[26]) && (
            <>
              {/* exchange rate table start */}
              {/* table start */}
              <div className="table-section-box">
                <RazorTable headerList={tableHeaderList}>
                  {exchange_rates?.data?.map((chi: any, idx: any) => {
                    return (
                      <RazorTableRow
                        key={idx}
                        one={
                          <ExchangeCurrencyText
                            curOne={chi?.source_currency?.code || "NIL"}
                            curTwo={chi?.destination_currency?.code || "NIL"}
                            urlOne={
                              chi?.source_currency?.code === "USD"
                                ? ""
                                : chi?.source_currency?.code === "EUR"
                                ? ""
                                : chi?.source_currency?.code === "GBP"
                                ? ""
                                : chi?.source_currency?.code === "NGN"
                                ? ""
                                : chi?.source_currency?.logo
                            }
                            urlTwo={
                              chi?.destination_currency?.code === "USD"
                                ? ""
                                : chi?.destination_currency?.code === "EUR"
                                ? ""
                                : chi?.destination_currency?.code === "GBP"
                                ? ""
                                : chi?.destination_currency?.code === "NGN"
                                ? ""
                                : chi?.destination_currency?.logo
                            }
                          />
                        }
                        two={RazorNumberFormat(chi?.rate, {
                          symbol: chi?.rate?.symbol,
                          // hideDecimal: true,
                          hideSymbol: true,
                        })}
                        three={chi?.provider?.replaceAll("-", " ") || "---"}
                        four={
                          chi?.updated_at
                            ? formatTime(chi?.updated_at || "")
                            : "---"
                        }
                        five={
                          <TitleTextFragment
                            titleSize="1.25rem"
                            text={chi?.updated_by?.email || ""}
                            title={`${chi?.updated_by?.first_name || ""} ${
                              chi?.updated_by?.last_name || ""
                            }`}
                            // textColor='red'
                          />
                        }
                        loading={loading}
                      />
                    );
                  })}
                </RazorTable>
              </div>
              {/* table end */}
              {/* pagination start */}
              <PaginationFragment
                currentPage={exchange_rates?.meta?.current_page || 1}
                perPage={exchange_rates?.meta?.per_page}
                totalPage={exchange_rates?.meta?.total}
                onPageChange={(num) => {
                  setCurrentPage(num);
                }}
                hidePagination={loading}
              />
              {/* pagination  end */}
            </>
          )}
          {/* exchange rate table end */}
        </div>
      </DashboardLayoutMain>
    </>
  );
};

export default DashboardOverview;
